type SavedItemOrUserObject = SavedItem | Area | Track | Waypoint | Folder;

/**
 * We use two different properties to determine whether an item is in a folder:
 *
 *  1. `folder`, which comes from the server.
 *      - If the item hasn’t been updated locally, it will have a `folder` property but no `parent_folder_id`
 *  2. `parent_folder_id,` which gets added once the item has been updated locally.
 *      - If this property is present, that means `folder` is stale, and we need to consider `parent_folder_id` the new source of truth
 *
 * `parent_folder_id` can be a string or null. If an item has been unfiled during the current session,
 * it will have the properties {folder: 'some_id', parent_folder_id: null}.
 * In short, if `parent_folder_id` is present, take it, regardless of value, otherwise fall back to `folder`.
 */
function getParent(savedItem: SavedItem | Folder) {
    if (typeof savedItem.parent_folder_id === 'string' || savedItem.parent_folder_id === null) {
        return savedItem.parent_folder_id;
    }
    // Bulk item endpoint returns an empty string
    if (savedItem.folder === '') return null;
    return savedItem.folder;
}

export default function getParentFolderId(item: SavedItemOrUserObject) {
    if ('properties' in item) {
        return getParent(item.properties);
    }
    return getParent(item);
}
